import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { PodType, TopEventsPodData } from '../top-events.model';

@Component({
    selector: 'ms-top-events-pod-body',
    templateUrl: 'top-events-pod-body.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TopEventsPodBodyComponent {
    @Input() pod: TopEventsPodData;
    @Input() index: number;
    allowHeaderCollapse = false;

    @HostBinding('class') className = 'pod-body';

    podType = PodType;
}
